@use '@dixa/lib-shared-tokens/scss' as *;

.connector {
  font-family: var(--dixa-typography-family-code);
}

.content {
  flex: 1 1 auto;
  min-width: 0;
}

.error {
  font-family: var(--dixa-typography-family-code);
  font-size: var(--dixa-typography-size-200);
}

.codeBlock {
  margin: 0;
  padding: var(--dixa-size-spacer-200);
  font-family: var(--dixa-typography-family-code);
  font-size: var(--dixa-typography-size-200);
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--dixa-typography-color-primary);
  background: var(--dixa-color-neutral-100);
  border: 1px solid var(--dixa-color-neutral-200);
  border-radius: var(--dixa-size-border-radius-100);
}
